// src/components/MobileBottomSheet.jsx
import { useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SummaryDrawer from "./SummaryDrawer";
import ProductReviews from "./ProductReviews";
import AddToCart from "./AddToCart";
import { useData } from "../context/DataContext";
import { usePricing } from "../hooks/usePricing";

export default function MobileBottomSheet() {
  const [open, setOpen] = useState(false);
  const { basketItem } = useData();
  const { totalPrice } = usePricing();
  const lineCount = basketItem?.lines?.length || 0;

  return (
    <>
      {/* Floating Cart Button */}
      <Button
        onClick={() => setOpen(true)}
        variant="contained"
        size="large"
        startIcon={<MenuIcon />}
        sx={{
          display: open ? "none" : "flex",
          position: "fixed",
          bottom: 16,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1100, // Below Drawer (1300)
          borderRadius: 8,
          boxShadow: 6,
          fontWeight: "bold",
          px: 4,
          py: 1.5,
          backgroundColor: "#1a237e", // Apply requested dark blue background
          "&:hover": {
            backgroundColor: "#0d47a1",
          },
        }}
      >
        View Order ({lineCount})
      </Button>

      {/* Bottom Sheet */}
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            height: "70vh",
            borderRadius: "24px 24px 0 0",
            overflow: "hidden",
          },
        }}
      >
        {/* Drag Handle + Header */}
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Box
            sx={{
              width: 40,
              height: 5,
              bgcolor: "grey.400",
              borderRadius: 3,
              mx: "auto",
              mb: 2,
            }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              Order Summary
            </Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <ProductReviews />
        </Box>

        <Divider />

        {/* Scrollable Content */}
        <Box sx={{ flex: 1, overflowY: "auto", px: 3, pb: 20 }}>
          <SummaryDrawer />
        </Box>

        {/* Fixed Add to Cart */}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            bgcolor: "background.paper",
            borderTop: "1px solid",
            borderColor: "divider",
            boxShadow: "0 -4px 12px rgba(0,0,0,0.05)",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              px: 1,
            }}
          >
            <Typography variant="subtitle1" fontWeight="bold">
              Total Order:
            </Typography>
            <Typography variant="h6" fontWeight="bold" color="primary">
              ${(totalPrice || 0).toFixed(2)}
            </Typography>
          </Box>
          <AddToCart />
        </Box>
      </Drawer>
    </>
  );
}
